import { CommonTranslation, ExtranetTranslation } from './finnish'

export const languageEn: ExtranetTranslation = {
  pageTitle: 'OmaPro Portal',
  menu: {
    home: 'Homepage',
    services: 'Services',
    omaAnnosServices: 'Oma-annos services',
    omaAnnosService: 'Oma-annos service',
    omaAnnosOrders: 'Orders',
    omaAnnosOrderHistory: 'Order history',
    omaAnnosOrderSchedules: 'Order schedules / Schedule deviations',
    omaAnnosProducts: 'Range of products',
    omaAnnosPhysicalProducts: 'Order of dose dispensing materials',
    omaAnnosOrderTickets: 'Order correction requests',
    omaAnnosProductShortages: 'Shortages',
    omaAnnosCustomership: 'My customer account',
    omaAnnosCustomerGroupManagement: 'Customer group management',
    omaProServices: 'OmaPro services',
    omaProMobile: 'OmaPro Mobile',
    medicineIdentification: 'Medicine identifier',
    support: 'Support',
    newsletters: 'News',
    faq: 'Frequently asked questions',
    contact: 'Contact',
    materials: 'Materials',
    shop: 'Shop',
  },
  userMenu: {
    ownCustomership: 'My customer account',
    changeCustomership: 'Change customer',
    selectLanguage: 'Select language',
    logout: 'Log out',
    infoAndUsers: 'Business information and users',
    deliveryDetails: 'Delivery details',
  },
  newsletters: {
    title: 'News',
    allNewsletters: 'All news',
  },
  faq: {
    title: 'Frequently asked questions',
  },
  user: {
    title: 'My information',
    userRoles: 'User roles',
    marketingAuthorization: 'Marketing permission',
    marketingAuthorizationInfo:
      'This permission allows you to stay updated on new products, services, and offers that may interest you. You can withdraw consent at any time.',
    marketingAuthorizationApproved: 'Marketing permission approved on',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyInfo:
      'Read how we handle your data securely and reliably. Accept the privacy policy to continue.',
    privacyPolicyLinkText: 'Privacy policy for the OmaPro portal',
    privacyPolicyApproved: 'Privacy policy approved on',
    cookies: 'Cookies',
    cookieInfo:
      'We collect cookies for visitor tracking and marketing. Do you accept the cookie policy?',
    termsOfUse: 'Terms of use',
    termsOfUseInfo:
      'We apply the following terms of use to the service. After reviewing and accepting them, you can continue.',
    termsOfUseLinkText: 'Terms of use for the OmaPro portal',
    termsOfUseApproved: 'Terms of use approved on',
    infoUpdatedSuccessfully: 'User information editing was successful',
    deletedSuccessfully: 'User removal was successful',
    approvalChangedSuccessfully: 'Consents were successfully modified',
    approvalModalTitle: 'Continue logging in by accepting the Privacy Policy and Terms of Use',
  },
  medicines: {
    title: 'Range of products',
    productNumber: 'Product number',
    productName: 'Name',
    strength: 'Strength',
    activeSubstancesDescription: 'Active substance',
    manufacturerName: 'Manufacturer',
    availableForCustomers: 'Availability',
    halving: 'Splittable in dose dispensing',
    halvable: 'Splittable',
    alwaysHalvable: 'Only splittable',
    available: 'Available',
    inShortSupply: 'Running out',
    outOfStock: 'Out of stock',
    toBeDiscontinued: 'Being removed from selection',
    discontinued: 'Removed from selection',
    drugFormatDescription: 'Form of medicine',
    tabletSplit: 'Splittability',
    crushable: 'Crushability',
    additionalDosageInformation: 'Additional dosage information',
    lactose: 'Lactose',
    medicineManual: 'Guide to medicines',
    medicineType: 'Type of product',
    showMoreInfo: 'Show details',
    closeMoreInfo: 'Close details',
    searchManufacturer: 'Search by manufacturer',
    pharmaceuticalGroup: 'Pharmaceutical group',
    substituteProduct: 'Substitute product',
    drug: 'Narcotic',
    psychoClass: 'PKV medicine',
    trafficHazard: 'Affects the ability to drive',
    fimeaClass: 'Meds75+ class + comment (Fimea)',
    activeSubstance: 'Active substance',
    takingTheMedicine: 'Administration',
    influence: 'Mechanism of action',
    dosage: 'Dosage',
    purpose: 'Indication',
    sideEffects: 'Side effects',
    pregnancy: 'Pregnancy and lactation',
    storage: 'Storage',
    appearance: 'Appearance',
    unknown: 'Unknown',
    filters: {
      Available: 'Available',
      InShortSupply: 'Running out (medicine shortage)',
      OutOfStock: 'Out of stock (medicine shortage)',
      ToBeDiscontinued: 'Being removed from selection',
      Discontinued: 'Removed from selection',
      halvingYes: 'Splittable',
      halvingNo: 'Not splittable',
      halvingAlways: 'Only splittable',
      drug: 'Medicine',
      supplement: 'Dietary supplement',
    },
    isHalvable: {
      '2': 'Only halvable',
      '1': 'Halvable',
    },
    isSplittable: {
      '0': 'Not to be splitted',
      '1': 'Can be splitted',
      '2': 'Only to help swallowing',
      '3': 'Unknown',
      '4': 'Not to be splitted',
      '5': 'Can be splitted',
      '6': 'Only to help swallowing',
      '7': 'Unknown',
      '9': 'Unknown',
    },
    isLactose: {
      '0': 'Does not contain lactose',
      '1': 'Contains lactose',
    },
    isCrushable: {
      '0': 'Not crushable',
      '1': 'Can be crushed',
      '9': 'Unknown',
    },
  },
  customer: {
    title: 'My customer account',
    customerInfo: 'Business information',
    customerUserList: 'Users',
    businessName: 'Customer name',
    businessId: 'Business ID',
    taxCode: 'VAT number',
    invoiceAddress: 'E-invoicing address',
    operatorId: 'Operator ID',
    doseDeliveryContactPerson: 'Contact person for dose-dispensing',
    kelaNumber: 'Kela number',
    doseDeliveryEmailAddress: 'Dose-dispensing e-mail',
    doseDeliveryPhoneNumber: 'Dose-dispensing phone number',
    invoicingInfo: 'Billing information',
    deliveryInfo: 'Delivery information',
    pharmacyInfo: 'Pharmacy information',
    addUser: 'Create new user',
    inviteLinks: 'Invite links',
    pharmacist: 'Pharmacist',
    removeUser: 'Delete user',
    removeUserTitle: 'Delete user',
    removeUserDesc:
      'You are about to delete a user account from OmaPro Portal. After deletion, the user will no longer have access to OmaPro Portal. Do you want to delete the user account?',
    roles: {
      'customer-pharmacist': 'Pharmacist',
      'customer-user': 'Basic User',
      'customer-user-management': 'User management',
      'customer-view-orders': 'Dose-dispensing orders',
      'customer-buyer': 'Purchasing rights',
      'invoice-viewing': 'Authorization to view invoices',
      'company-information-management': 'Company information management',
      'contract-information-viewing': 'Authorization to view contract details',
    },
    newUser: 'New user',
    sendInviteLink: 'Send invitation link',
    newUserModalTitle: 'Add a new user',
    newUserModalDescription: 'You have sent an invitation link to the following email address:',
    newInviteLinkExpiresIn: 'The invitation link is valid for 60 minutes.',
    ordersApiKeyTooltip:
      "The password can only be changed via the Portal by the customer account's primary user.",
    ordersApiKeyTitle: 'Order interface password',
    ordersApiKeyDisclaimer:
      'Start changing the order interface password by clicking the Create new password button. After confirmation, the new password will appear in the field below, allowing you to copy it to the clipboard. The new password takes effect immediately and must be updated in the pharmacy system directly after the reset.',
    ordersApiKeyResetButton: 'Create new password',
    ordersApiKeyCopyToClipboard: 'Copy to clipboard',
    ordersApiKeyModalDisclaimer:
      'You are about to create a new password for the order interface. The new password will take effect immediately and must be updated in the pharmacy system directly after the reset. Do you want to continue?',
    ordersApiKeyModalOkButton: 'Create new password',
    ordersApiKeyModalTitle: 'Change order interface password',
    reports: {
      reports: 'Reports',
      reportType: 'Report type',
      download: 'Download report',
      formReport: 'Generate report',
      noReportToShow: 'No report to display',
      timeInterval: 'Time period',
      purchaseReport: 'Purchase Report',
      productBreakdown: 'Product Breakdown',
      customerGroupBreakdown: 'Customer Group Breakdown',
      timeIntervalTooltip: 'Select a time period of up to 31 days. The report content is generated based on the deliveries within the selected period.',
      reportTypeTooltip: 'Customer Group Breakdown = Order data by customer group. Purchase Report = Products grouped into taxable and non-taxable pharmacy items.',
      modalTitle: 'The report is being generated, please wait a moment.'
    },
  },
  customerService: {
    customerInfoLink: 'Customer info',
    customerSelectInput: {
      placeholder: 'Select customer',
      searchInstruction: 'Enter at least 3 characters',
    },
  },
  extranetCard: {
    buttonLabel: 'Read more',
  },
  orderHistory: {
    title: 'Order history',
    orderCount: 'Orders',
    select: 'Select',
    orderDate: 'Order date',
    customerGroup: 'Customer group',
    groupOrderCount: 'Order quantity',
    orderState: 'Order status',
    name: 'Name',
    dateOfBirth: 'Date of birth',
    subscriptionPeriod: 'Order period',
    orderNumber: 'Order number',
    comments: 'Notes',
    deliveryDate: 'Shipping date',
    orderChanges: 'Order changes',
    orderChange: 'Order change',
    urgent: 'Rush order',
    productNumber: 'Product number',
    showOrderChanges: 'Show only orders with changes',
    status: {
      arrived: 'Received',
      'in-manufacturing': 'In production',
      'missing-information': 'Awaiting information',
      sent: 'Sent',
      cancelled: 'Cancelled',
    },
    listOfChangesButton: 'Listing of changes',
    dosageCards: 'Dosage cards',
    dosageCardButtonMobileTooltip: 'The order status must be "Sent" to allow printing.',
    dosageCardButtonTooltip:
      'Select the orders or customer groups to be printed. The order status must be "Sent" to allow printing.',
    orderChangesButtonTooltip:
      'Select the orders whose changes you want to view or print. At least one order with changes must be selected. The list will open in a separate window.',
    vnrSearchPlaceholder: 'Filter by product number',
  },
  productShortages: {
    title: 'Shortages',
    noShortages: 'No product shortages',
    allGood: 'Everything is fine!',
    subscriptionPeriodInfo:
      'The list shows customers whose most recent order period has included a product requiring attention.',
    replaceableProduct: 'Repaceable product',
  },
  inviteLinks: {
    openInvites: 'Open invitation links',
    inviteCreator: 'Creator of invitation link',
    InvitationLinkRecipientEmail: "Recipient's email for the invitation link",
    expires: 'Expires',
    usable: 'Available',
    roles: 'User roles',
    cancelInviteLink: 'Cancel invitation link',
    cancelInviteLinkModal: 'Invitation link cancellation',
    cancelInviteLinkDescription: 'Are you sure you want to cancel the invitation link to: ',
    cancelInviteLinkSuccess: 'Kutsulinkki poistettu onnistuneesti',
    signUpToExtranet: 'Log in to OmaPro Portal',
    inviteLinkExpired: 'Your invitation link is not valid.',
    inviteLinkAskNew: 'Request a new invitation link to continue logging in.',
    toSignin: 'Go to the login page',
    registration: {
      title: 'Welcome to OmaPro Portal',
      subtitle: 'Register by filling out the details below',
      usernamePlaceholder: 'Enter username',
      usernameMaxLengthError: 'The username can be at most 32 characters long',
      usernameMinLengthError: 'The username must be at least 5 characters long',
      usernamePatternError: 'The username must not contain spaces',
      passwordAgain: 'Password again',
      passwordPlaceholder: 'At least 15 characters',
      passwordMinLengthError: 'The password must be at least 15 characters long',
      passwordsDoNotMatch: 'The passwords do not match',
      passwordPatternError:
        'The password must contain uppercase and lowercase letters, numbers, and special characters',
      userNameTooltip:
        'Create a secure and easy-to-remember username by using lowercase letters and numbers. Avoid personal information and do not use the same username for different services. The username cannot contain special characters or the letters å, ä, or ö.',
      passwordTooltip:
        'The password must be at least 15 characters long and include uppercase and lowercase letters, numbers, and special characters',
      marketingAuthorizationInfo:
        'This permission allows you to stay updated on new products, services, and offers that may interest you. You can withdraw consent at any time.',
      privacyPolicyInfo:
        'Read how we handle your data securely and reliably. Accept the privacy policy to continue.',
      extranetPrivacyPolicy: 'OmaPro Portal Privacy Policy',
      extranettermsOfUse: 'OmaPro Portal Terms of Use',
      newUserSuccess: 'New user successfully created',
      newUserError: 'Failed to create a new user',
      newUserNameConflict: 'The username is already in use',
      emailTooltip:
        'The email address used is the one to which the invitation was sent. The email address can be changed later in personal settings.',
      countryTooltip:
        "Enter the country code, e.g., Finland's country code 'FI', according to the ISO 3166 standard.",
      selectProfessionalRoleTitle: 'Select professional roles',
      selectProfessionalRoleInfo:
        'Professional roles affect the content you see and expand your range of materials. By selecting a professional role, you confirm that you are authorized to view content intended for that target audience.',
      noSelectedProfessionalRole: 'No professional role',
    },
  },
  customerGroupSettings: {
    title: 'Customer group management',
    update: 'Customer group editor',
    customer: 'Customer',
    activity: 'Activity',
    selectPricing: 'Select dose dispensing fee',
    activityTooltip: 'The group status is active when orders have been made in the last 8 weeks.',
    doseDispensingFee: 'Dose-dispensing fee',
    doseDispensingFeeNotSet: 'Dose-dispensing fee not set',
    doseDispensingFeeTooltip:
      'Assign a dose-dispensing fee for the group. The fee is determined by the pricing agreement.',
    orderTime: 'Order deadline',
    orderTimeNotSet: 'Order deadline not set',
    orderTimeTooltip:
      'Set an order time for the group. Please contact our customer service before setting an order deadline if you plan to start a large amount (over 50 customers) at once or want to introduce a new order day. Note that the order time should only be changed for significant reasons in the future.',
    doseBagLayout: 'Appearance of dose bags',
    doseBagLayoutTooltip:
      'Select "Iso printti" if you want all customers in the group to have larger text on the date and time information on the dose pouches.',
    disclosure: 'Data sharing',
    disclosureTooltip:
      'By selecting a third party from the menu below, you give the dose dispensing unit the right to share the necessary dose dispensing data for the end user with that party. Note that the Smila medicine dispenser requires certain dose pouch information to function.',
    stickerlessGroup: 'Non-stickered group',
    stickerlessGroupTooltip:
      "Select 'Non-stickered group' if you want all the group's rolls to be without sealing stickers.",
    nextOrderDeadline: 'Next order deadline',
    selectedOrderDeadline: 'Selected order deadline',
    selectableOrderDeadline: 'Available order deadline',
    noSelectableTimes: 'No selectable times',
    smilaGroupSticker:
      'The Smila group must be non-stickered. Go back and select non-stickered group.',
    updateModal: {
      title:
        'Attention! You are about to change the settings for the customer group. The new settings will take effect from the next order. ',
      content:
        'Please note that production volumes are closely monitored, and order times should only be changed for significant reasons. Please contact our customer service well in advance of the change date if the change concerns a large number (over 50 customers) at once.',
      confirmation: ' Do you want to save the changes for the customer group?',
    },
    normalLayout: 'Normal',
    bigFontLayout: 'Iso Printti',
    notSet: 'Not set',
    scheduleNotSet: 'No schedule set',
    groupUpdatedSuccessfully: 'Group successfully edited',
    contract: 'Agreement',
    dataRelease: 'Not released',
    nextOrderTime: {
      notSet: 'Not set',
      nextOrderDeadline: 'Next order deadline',
      selectedOrderDeadline: 'Selected order deadline',
      availableOrderDeadline: 'Available order deadline',
    },
    nextOrderDeadlineTooltip:
      'This is a predicted order deadline based on the regular schedule and does not take into account any separately agreed schedule deviations or public holidays. Please check the detailed order schedules on the "Order schedules / Schedule deviations" page.',
  },
  unauthorized: {
    welcome: 'Welcome to OmaPro Portal',
    redirect: 'You will be redirected automatically in 10 seconds',
    noAuth: 'No access',
    noLink: 'No customer is linked to the username',
  },
  physicalProducts: {
    orderMaterialTabTitle: 'Material order',
    orderedMaterialTabTitle: 'Ordered materials',
    totalPrice: 'Total price',
    total: 'Total',
    vat: 'VAT',
    vatLowercase: 'vat',
    priceByPcs: 'Unit price',
    orderDate: 'Order date',
    shoppingCartButton: 'Order',
    freeMaterial: 'Free',
    priceTooltip:
      'Materials will be invoiced with the next dose dispensing order. Ordering priced materials requires the Purchasing rights role.',
    quantityTooltip:
      'The maximum order quantity is 30 pcs per material. If you need to order a larger quantity at once, please contact your representative before placing the order.',
    shoppingCart: {
      title: 'Order summary',
      sendOrder: 'Submit order',
      footerMessage: 'Ordered materials will arrive with the next dose dispensing delivery.',
      orderSuccess: 'Order sent successfully',
    },
  },
  correctionRequests: {
    titleTooltip:
      'An order correction request is submitted if a product in the order suddenly becomes unavailable.  In that case, a new order must be placed for the customer as soon as possible, without marking it as a rush order. Once the new order has been placed, the correction request must be marked as completed under the Active requests tab.',
    activeRequests: 'Active requests',
    checkedRequests: 'Completed requests',
    requestArrivedAt: 'Correction request received',
    missingProduct: 'Unavailable product',
    substituteProduct: 'Substitute product',
    requestCheck: 'Mark correction request as completed',
    requestCheckByPharmac: 'Correction request expired',
    requestCheckTooltip:
      'By marking the correction request as completed, you confirm that it has been handled and a new order has been placed.',
    requesCheckedBy: 'Correction request completed',
    requesCheckedSuccess: 'Correction request successfully marked as completed',
    noCorrectionRequests: 'No correction requests',
    customerName: "Customer's name",
    searchByName: 'Search by name',
  },
  contact: {
    openTicketsTabTitle: 'Open conversations',
    closedTicketsTabTitle: 'Closed conversations',
    startNewTicketButton: 'Start a new conversation',
    newTicketModalTitle: 'New conversation',
    newTicketModalInfo:
      'You can use this channel to securely contact us regarding any matters. We respond to inquiries during customer service opening hours.',
    subject: 'Subject',
    subjectAreaLabel: 'Subject area',
    subjectAreaInfo: 'Select the topic area that best describes your matter.',
    confidentialTicketButton: 'Contains confidental information',
    confidentialTicketInfo:
      'Mark the message as confidental if it contains, for example, identifiable personal data. The conversation description, attachments, and comments will be deleted according to the retention period defined in the privacy policy.',
    confidentialTicketInfoLinkText: 'Privacy policy',
    privateTicketButton: 'Private conversation',
    privateTicketInfo:
      'A private conversation is visible only to you and the customer service representative.',
    state: 'Status',
    createdAt: 'Created',
    updatedAt: 'Updated',
    writer: 'Author',
    description: 'Description',
    attachments: 'Attachments',
    addAttachment: 'Attach file',
    comments: 'Comments',
    addComment: 'Add comment',
    sendButton: 'Send',
    reopenTicket: 'Reopen conversation',
    cancelTicket: 'Cancel conversation',
    cancelTicketModal:
      'Are you sure you want to cancel this conversation? Select "Cancel conversation" if the conversation is unnecessary. Canceled conversations cannot be reopened.',
    closeTicket: 'Resolve conversation',
    closeTicketModal:
      'Are you sure you want to resolve this conversation? Select "Resolve conversation" once you’ve received a response and your issue has been resolved. Resolved conversations can be reopened within 5 days, if needed.',
    new: 'New',
    inProgress: 'In progress',
    repliedByPharmac: 'Replied by Pharmac',
    closed: 'Closed',
    cancelled: 'Cancelled',
    resolved: 'Resolved',
    commentAddedToast: 'Comment added',
    noComments: 'No comments yet',
    wrongFileTypeError: 'Wrong file format, allowed file formats are .pdf, .jpg, .png, .webp',
    acceptableFileTypes: 'Allowed file format: .pdf, .jpg, .png, .webp',
  },
  orderSchedules: {
    titleTooltip:
      'If you wish to make changes to the planned schedule deviations, please contact Pharmac using the contact form',
    onlyExceptionsSwitch: 'Show only deviations',
    orderPrediction: 'Order forecast',
    exceptions: 'Deviations',
    periodLength: 'Length of period',
    atThePharmacy: 'Delivered to pharmacy',
    double: 'Doubling',
    transfer: 'Shift',
    noExceptions: 'No deviations',
    doubledOffDate: 'Doubled off from day',
    transferedOffDate: 'Shifted off from day',
    includesExceptions: 'Contains deviations',
    expectionDate: 'Deviating order deadline',
    movedFromDate: 'Shifted from day',
    movedFromDates: 'Shifted from days',
    doubledFromDate: 'Doubled from day',
    doubledFromDates: 'Doubled from days',
    removedFromDate: 'Removed from the day',
    noExceptionSchedules: 'No schedule deviations',
    noOrderSchedulesDesc:
      'Place your first order and set up schedules to see order schedule forecasts.',
    days: 'days',
    removed: 'Removal',
  },
  billedDeliveries: {
    deliveryNumber: 'Delivery number',
    shippingDate: 'Shipping date',
    deliveryBreakdown: 'Product- and order-specific breakdown',
    orderBreakdown: 'Order-specific breakdown and the purchase report',
    searchByDeliveryNumber: 'Search by delivery number',
    deliveryBreakdownTooltip:
      'Select the printable breakdown by product and order. Due to the large file size, only one breakdown can be downloaded at a time. If multiple rows are selected, the download button will be disabled.',
    orderBreakdownTooltip:
      'Select the printable order-specific breakdowns and the purchase reports. Due to the large file sizes, you can download up to 10 breakdowns at a time. If more than 10 rows are selected, the download button will be disabled.',
  },
  shop: {
    allProducts: 'All products',
    wholeCatalog: 'Full selection',
    ownProducts: 'My products',
    noOwnProducts:
      'Hello! The available instructions, guides, webinars, contract templates, and trainings can be acquired for your use from the OmaPro Portal store. Once you have aquired the materials, you will always find them collected here.',
    noBuyerRoleTooltip: 'You do not have purchasing rights. Please contact your primary user.',
    purchaseRightDeniedTooltip: 'Purchase not allowed',
    noRequiredProfRolesTooltip:
      'You do not have the professional role required to activate this product',
    noRequiredProfRolesForDownloadTooltip:
      'Sinulla ei ole tuotteen lataamiseen tarvittavaa ammattiroolia',
    published: 'Published',
    availableIndefinitely: 'Unlimited access',
    addedToOwnProducts: 'Added to my products',
    removedFromOwnProducts: 'Product removed from my products',
    cart: {
      emptyCartTitle: 'Your shopping cart is empty',
      emptyCartDesc:
        'Explore our range of products and services. You can purchase products by adding them to your shopping cart.',
      emptyCartButton: 'Go to shop',
      acceptTerms: 'I accept the terms and conditions of purchase and delivery. Read the terms ',
      here: 'here.',
      missingRoles:
        'You can purchase this product, but you cannot activate it because you lack the required professional role. Remove the product from your cart or proceed with the order if you are buying it as a gift.',
      orderSendSuccess: 'Order sent successfully',
      totalPrice: 'Total excl. VAT',
    },
    filters: {
      order: 'Order',
      alphabetically: 'Alphabetically',
      newest: 'Newest first',
      oldest: 'Oldest first',
      cheapest: 'Cheapest first',
      mostExpensive: 'Most expensive first',
      priceType: 'Price type',
      fee: 'Paid',
      free: 'Free',
      tags: 'Tags',
    },
    removeProductModal: {
      title: 'Remove product',
      description:
        'You are removing the product from your products. You can add the product back to your products at any time from the All products tab.',
    },
    product: {
      viewable: 'Available to watch',
      till: 'until',
      unlimitedAccess: 'Unlimited access',
      preview: 'Preview video',
      notActivated: 'The product has not been activated',
      requiredRoles: 'Required professional roles',
      noRequiredRoles: 'No specific requirements',
      activated: 'The product has been activated',
      videoNotAvailable: 'Video not available',
      pictureNotAvailable: 'Image not available',
    },
    buttons: {
      buyAgain: 'Buy again',
      learnMore: 'Learn more',
      addToCart: 'Add to cart',
      removeFromCart: 'Remove from cart',
      addToOwnProducts: 'Add to my products',
      goTo: 'View',
      downloadDocument: 'Download document',
      activate: 'Activate',
      activeteProduct: 'Activate product',
      downloadTemplate: 'Download the ',
    },
    activateCodeModal: {
      title: 'Activate product code',
      addCode: 'Enter code',
      customer: 'You are activating the product as a customer of',
      usageTime: 'Usage time',
      roleError:
        'You do not have the professional role required to activate this product. You can find the required professional roles in the product description.',
      codeError: 'The code you entered is incorrect',
      expiredError: 'The product can no longer be activated',
      usedError: 'The activation code has already been used',
      activatedError: 'The product has already been activated',
      activateProductSuccess: 'Product activated successfully',
    },
    orders: {
      shopOrders: 'Webshop orders',
      orderNumber: 'Order number',
      orderDate: 'Order date',
      orderStatus: 'Order status',
      totalPrice: 'Total price excl. VAT',
      purchaserName: 'Buyer',
      statuses: {
        arrived: 'Received',
        cancelled: 'Cancelled',
        beingProcessed: 'Processing',
        delivered: 'Delivered',
        partiallyDelivered: 'Partially delivered',
        completed: 'Ready',
        sent: 'Sent',
      },
      orderRow: 'Order row',
      productName: 'Product name',
      quantity: 'Quantity',
      unitPrice: 'Unit price',
      status: 'Status',
      deliveryNumber: 'Delivery number',
      codes: {
        externalUser: 'External user',
        used: 'Used',
        unused: 'Unused',
        activationCodes: 'Activation codes',
        copy: 'Copy',
      },
    },
  },
  shopProducts: {
    document: 'Document',
    video: 'Video',
    videos: 'Video recordings',
    serviceProduct: 'Service',
    serviceProducts: 'Services',
    physicalProduct: 'Additional product',
    documents: 'Documents',
    materialType: 'Material type',
    releaseDateRange: 'Publication date range',
    description: 'Description',
    chapters: 'Parts',
    goTo: 'View',
    downloadDocument: 'Download document',
    relatedProducts: 'Additional products',
  },
  footer: {
    contact: 'Contact us',
    links: 'Links',
    privacyPolicy: 'Privacy policy',
    termsOfUse: 'Terms of use',
    shopTermsAndConditionsOfContractAndDelivery: 'Webshop agreement and delivery terms',
    oivaReport: 'Oiva report',
  },
}

export const commonEn: CommonTranslation = {
  greeting: 'Hi',
  yes: 'Yes',
  no: 'No',
  welcome: 'Welcome',
  home: 'Home',
  users: 'Users',
  orders: 'Orders',
  pharmacies: 'Pharmacies',
  taksa: 'Taksa',
  catalog: 'Catalog',
  admin: 'Administration',
  accept: 'Accept',
  settings: 'Settings',
  logout: 'Logout',
  login: 'Login',
  signUp: 'Register',
  deleted: 'Deleted',
  arrived: 'Arrived',
  return: 'Return',
  search: 'Search...',
  noSearchResultsTitle: 'No results',
  noSearchResultsDescription: 'Check or broaden you search criteria',
  notFoundPageTitle: 'Etsimääsi sivua ei löydy!',
  notFoundPageMessage: 'Siirry etusivun tai valikon kautta haluamallesi sivulle.',
  filters: 'Filters',
  category: 'Category',
  categories: 'Categories',
  favourite: 'Favorite',
  firstName: 'First name',
  lastName: 'Last name',
  phoneNumber: 'Phone number',
  streetName: 'Street address',
  emailAddress: 'Email address',
  postCode: 'Postal code',
  townName: 'City',
  userName: 'Username',
  countryCode: 'Country code',
  country: 'Country',
  certificateCardNumber: 'Certificate card number',
  clipboardSuccess: 'Copied to clipboard',
  clipboardError: 'Failed to copy',
  password: 'Password',
  changePassword: 'Change password',
  cancel: 'Cancel',
  save: 'Save',
  basicInfo: 'Basic information',
  contactPersonName: 'Contact person',
  edit: 'Edit',
  moreInfo: 'Additional information',
  week: 'Week',
  selectDateRange: 'Set date range',
  selectDate: 'Aseta päivämäärä',
  endDateText: 'End date',
  startDateText: 'Start date',
  clock: 'at',
  pcs: 'pcs',
  continue: 'Continue',
  alternateWeek: 'Alternating week',
  requiredFieldError: 'Mandatory information',
  emailPatternError: 'Invalid email address',
  active: 'Active',
  passive: 'Passive',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  mondayShort: 'Mon',
  tuesdayShort: 'Tue',
  wednesdayShort: 'Wed',
  thursdayShort: 'Thu',
  fridayShort: 'Fri',
  saturdayShort: 'Sat',
  sundayShort: 'Sun',
  class: 'Class',
  comment: 'Comment',
  chooseCustomer: 'Select the customer you represent from the list below to continue.',
  timeoutTitle: 'Your session is about to expire',
  timeoutContent1: 'You will be logged out automatically in',
  timeoutContent2: '. Do you want to continue using OmaPro Portal?',
  timeoutMinutes: 'minutes',
  timeoutSeconds: 'seconds',
  all: 'All',
  nb: 'Attention!',
  name: 'Name',
  quantity: 'Quantity',
  price: 'Price',
  professionalRoles: 'Professional roles',
  language: 'Language',
  fi: 'Finnish',
  sv: 'Swedish',
  en: 'English',
  roles: 'Roles',
  free: 'Free',
  remove: 'Remove',
  dayShort: 'Day',
  monthShort: 'Month',
  yearShort: 'yr',
  buyingBan: 'Purchase ban',
  einvoice: 'E-invoice',
  emailInvoice: 'Email invoice',
  printInvoice: 'Paper invoice',
}
